import React from 'react';
import PropTypes from 'prop-types';
import { scapeXMLcontent } from '../utils';
import './style.scss';

const InfoSection = ({
  className,
  labelTitle,
  labelDescription,
  enable,
  text,
}) => (
  <div className={`col-xs-12 ${className}`}>
    <h3 className="micuenta-title hasStickOnScroll">
      {`${labelTitle} `}
      {enable === 1 && (
        <i className="fa fa-check success" style={{ color: '#5cb85c' }} />
      )}
    </h3>

    <div>
      <div
        className="info-pin-rating"
        dangerouslySetInnerHTML={{
          __html: `${labelDescription} `,
        }}
      />
      {text && (
        <span className="label label-default item-rating">
          {scapeXMLcontent(text)}
        </span>
      )}
    </div>
  </div>
);

InfoSection.propTypes = {
  enable: PropTypes.number,
  text: PropTypes.string,
  className: PropTypes.string,
  labelTitle: PropTypes.string,
  labelDescription: PropTypes.string,
};

export default InfoSection;
